<template>
	<div>
		<div class="pull-left">
			<b-button @click="goBackToFrom" variant="outline-dark"><i class="fa fa-chevron-left"></i> {{ $t('back') }}</b-button>
		</div>
		<div class="pull-right">
			<b-button variant="success" class="mr-2" @click="print">{{ $t('save') }}</b-button>
		</div>
		<br>
		<br>
		<div class="doc-body">
			<b-card>
				<template #header>
<!--					<b>{{ $t('incomes.create.create') }}</b>-->
					<b-checkbox style="display: inline-block" switch/>
					<multiselect
						v-model="depId"
						:options="departments"
						track-by="id"
						:show-labels="false"
						:allow-empty="true"
						:multiple="true"
						label="name"
						@search-change="changeDep($event)"
						:placeholder="$t('promo-to-product.department')"
						style="max-width: 300px; display: inline-block"
					/>
					<b-form-select size="small" v-model="categoryId" :disabled="!depId" class="ml-3" style="width: 200px; display: inline-block">
						<option v-for="(selectOption, indexOpt) in categorys" :key="indexOpt" :value="selectOption.id">
							{{ selectOption.name }}
						</option>
						<template slot="first">
							<option :value="null">
								-- {{ 'Все группы' }} --
							</option>
						</template>
					</b-form-select>
					<b-form-select size="small" v-model="subCategoryId" :disabled="!depId" class="ml-3" style="width: 200px; display: inline-block">
						<option v-for="(selectOption, indexOpt) in subCategorys" :key="indexOpt" :value="selectOption.id">
							{{ selectOption.name }}
						</option>
						<template slot="first">
							<option :value="null">
								-- {{ 'Все категории' }} --
							</option>
						</template>
					</b-form-select>
					<b-form-select size="small" v-model="subSubCategoryId" :disabled="!depId" class="ml-3" style="width: 200px; display: inline-block">
						<option v-for="(selectOption, indexOpt) in subSubCategorys" :key="indexOpt" :value="selectOption.id">
							{{ selectOption.name }}
						</option>
						<template slot="first">
							<option :value="null">
								-- {{ 'Все подкатегории' }} --
							</option>
						</template>
					</b-form-select>
				</template>
			</b-card>
		</div>
	</div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import UsersService from "../../services/users.sevice";
import ReferencesService from "../../services/references.sevice";
export default {
	name: "PriceCreate",
	components: {Multiselect},
	data() {
		return {
			depId: null,
			departments: [],
			categoryId: null,
			categorys: [],
			subCategoryId: null,
			subCategorys: [],
			subSubCategoryId: null,
			subSubCategorys: []
		}
	},
	computed: {
	},
	watch: {
	},
	methods: {
		goBackToFrom() {
			this.$router.back();
		},
		changeDep() {
			ReferencesService.getSubReferenceChildren(id)
		}
	},
	created() {
		UsersService.getPermittedDepartments().then(res => {
			this.departments = res.data.permittedDepartments
		})
	}
}
</script>

<style scoped>

</style>
